import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Anulat',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Primită',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Confirmată',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'În pregătire',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'Pe drum',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Gata',
  status: {
    actual: 'Curent',
    pending: 'În așteptare',
  },
  warning_label: {
    pickup_time_changed: '{{company}} a schimbat ora din {{initialTime}} în {{currentTime}}',
  },
  labels: {
    order_number: 'Nr. comandă: {{number}}',
    today: 'Azi',
  },
};
